import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, CircularProgress, Grow, IconButton, Link, Typography, } from "@mui/material";
import { ArrowCircleLeft, EnvelopeSimple, Phone, Trash, User, } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import ContactObjectApi from "../../../infrastructure/api/pages/contact-object-api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Info } from "@phosphor-icons/react/dist/ssr";
const RoofAccessContactCard = ({ object, contact, onclickCard, openModal, refresh, contactPersonType, contractId, }) => {
    const { t: translate } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [isCardFlipped, setIsCardFlipped] = useState(false);
    const handleInfoButtonClick = () => {
        setIsCardFlipped(true);
    };
    useEffect(() => {
        console.log(contactPersonType);
    }, []);
    const handleArrowLeftButtonClick = () => {
        setIsCardFlipped(false);
    };
    const onClickCard = (contact) => {
        onclickCard(contact);
        openModal();
    };
    const onDelete = (id) => {
        setLoading(true);
        ContactObjectApi.DeleteContactObject(id, contractId)
            .then((res) => {
            if (res.data && res.status) {
                toast.info(translate("DeletedSuccessfully"));
                refresh(true);
            }
            else {
                toast.error(translate("ErrorDelete"));
            }
        })
            .catch(() => {
            console.error("Error while deleting Contact Object");
        })
            .finally(() => setLoading(false));
    };
    const handlePhoneNumberClick = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };
    return (_jsxs(_Fragment, { children: [!isCardFlipped && (_jsx(Grow, { in: !isCardFlipped, children: _jsx(Box, { sx: {
                        width: {
                            xs: "100%",
                            sm: "49%",
                            md: "100%",
                            lg: "49%",
                        },
                        padding: {
                            xs: 0.5,
                            sm: 1,
                            md: 2,
                        },
                    }, className: "contact-card", children: _jsxs(Box, { sx: { display: "flex" }, children: [_jsx(Box, { sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    gap: 0.5,
                                    flex: "1 1 auto",
                                }, children: _jsx(Box, { className: "user-icon", sx: {
                                        width: 28,
                                        height: 28
                                    }, children: _jsx(User, {}) }) }), _jsxs(Box, { sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: 0.5,
                                    flex: "1 1 auto",
                                }, onClick: (event) => {
                                    // Check if the clicked element is a link
                                    if (event.target.tagName.toLowerCase() !== "a") {
                                        onClickCard(contact);
                                    }
                                }, children: [_jsx(Typography, { className: "name-heading", children: contact.name }), _jsxs(Box, { sx: { display: "flex", gap: 0.5, alignItems: "center" }, children: [_jsx(Phone, { size: 24, color: "#495057" }), _jsx(Link, { className: "card-body-text", style: { cursor: "pointer" }, onClick: () => handlePhoneNumberClick(contact.phoneNumber), target: "_blank", rel: "noreferrer", children: contact.phoneNumber })] }), _jsxs(Box, { sx: {
                                            display: "flex",
                                            gap: 0.5,
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }, children: [_jsx(Box, { sx: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                }, children: _jsx(EnvelopeSimple, { size: 24, color: "#495057" }) }), _jsx(Link, { className: "card-body-text", href: `mailto:${contact.email}`, target: "_blank", rel: "noreferrer", sx: {
                                                    wordWrap: "break-word",
                                                    whiteSpace: "pre-wrap",
                                                    overflowWrap: "anywhere",
                                                    display: "inline-block",
                                                }, children: contact.email })] }), object.map((name) => (_jsx(Box, { className: "object-tag", sx: {
                                            mt: 1,
                                            display: "flex",
                                            alignItems: "center"
                                        }, children: _jsx(Typography, { className: "object-tag-text", children: name }) })))] }), _jsxs(Box, { sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                    justifyContent: "space-between",
                                    gap: 0.5,
                                    flex: "1 1 auto",
                                }, children: [_jsx(Info, { size: 28, onClick: handleInfoButtonClick }), _jsx(Box, { onClick: (e) => {
                                            e.stopPropagation();
                                        }, className: "trashcontainer", sx: {
                                            width: 28,
                                            height: 28,
                                            display: "flex"
                                        }, children: _jsx(IconButton, { size: "small", sx: {
                                                // padding: {
                                                //   xs: "0px !important",
                                                //   sm: "0px !important",
                                                //   md: "0px !important",
                                                // },
                                                boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.04),0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 2px 1px 0px rgba(0, 0, 0, 0.01),0px 3px 1px 0px rgba(0, 0, 0, 0)",
                                                minWidth: 0,
                                                ":hover": { backgroundColor: "#f9f6ff" },
                                            }, onClick: (e) => {
                                                e.stopPropagation();
                                                onDelete(contact.id);
                                            }, disabled: loading, children: loading ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : (_jsx(Trash, { color: "#130922", size: 24 })) }) })] })] }) }) })), isCardFlipped && (_jsx(Grow, { in: isCardFlipped, children: _jsxs(Box, { sx: {
                        width: {
                            xs: "100%",
                            sm: "100%",
                            md: "100%",
                            lg: "49%",
                        },
                        padding: {
                            xs: 0.5,
                            sm: 1,
                            md: 2,
                        },
                        minHeight: "150px",
                    }, className: "contact-card", children: [_jsx(Box, { sx: {
                                display: "flex",
                                justifyContent: "flex-end"
                            }, children: _jsx(ArrowCircleLeft, { size: 32, onClick: handleArrowLeftButtonClick }) }), _jsxs(Box, { sx: { display: "flex", alignItems: "center", marginBottom: 1 }, children: [_jsx(Typography, { className: "name-heading", sx: { marginRight: 1 }, children: "Contactpersoon:" }), _jsx(Typography, { children: contactPersonType })] }), _jsxs(Box, { children: [_jsx(Typography, { className: "name-heading", children: "Instructions" }), _jsx(Box, { className: "scrollable-content", children: _jsx(Typography, { sx: { padding: "1%" }, children: contact.instructions }) })] })] }) }))] }));
};
export default RoofAccessContactCard;
